import styled, { css } from 'styled-components';
import { isMobileOnly } from 'react-device-detect';
import {
  DoconConfirmModal,
  DoconModal,
  DoconModalContent,
  DoconModalHeader,
  DoconModalFooter,
  ellipsis,
} from '@docon/docon-ui-library';
import { colors } from 'utilities/colorConfig';

const StyledConfirmModal = styled(DoconConfirmModal).attrs(() => ({
  cancelText: 'No',
  okText: 'Yes',
  type: 'warning',
}))`
  width: 85%;
  height: 50%;
  border-radius: 8px;

  overflow: hidden;
  position: relative;
  cursor: default;
  transition: all 0.5s ease-in;
  max-height: ${({ $maxHeight }: any) => $maxHeight || '200px'};
  max-width: ${({ $maxWidth }: any) => $maxWidth || '500px'};

  button { width: 100px;}

  ${DoconModalContent} {
    display: grid;
    place-content: center;
    white-space: pre-line;
    text-align: center;
  }

  ${() => isMobileOnly && css`
    --leftRightPadding: 20px;
  `}
`;

const StyledModal = styled(DoconModal)`
  width: 95%;
  height: 100%;
  border-radius: 8px;

  overflow: hidden;
  position: relative;
  cursor: default;
  transition: all 0.5s ease-in;
  max-height: ${({ $maxHeight }: any) => $maxHeight || '85%'};
  max-width: ${({ $maxWidth }: any) => $maxWidth || '950px'};
  --closeIconColor: ${colors.white};
  --paddingLeftRight: 16px;

  ${DoconModalContent} {
    max-height: initial;
    padding: 0;
    --contentPadding: 16px;
    background-color: ${colors.white};
  }

  ${DoconModalHeader} {
    font-size: 20px;
    line-height: 24px;
    color: ${colors.white};
    ${ellipsis};
    background-color: ${colors.appColor};
  }

  ${() => isMobileOnly && css`
    width: 100%;
    max-height: 100%;
    border-radius: 0;

    ${DoconModalHeader} {
      font-size: 18px;
      line-height: 20px;
      padding-right: 35px;
    }

    ${DoconModalFooter} {
      padding-right: var(--mobile-footer-pr-due-to-zendesk);
    }
  `}
`;

export {
  StyledConfirmModal,
  StyledModal,
};
